import React, { Component } from 'react';

// components
import Header from '../components/Header';
import Footer from '../components/Footer';

class Page extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelectorAll('header p').forEach((e) => {
      e.previousElementSibling.style.marginBottom = '0';
      e.classList.add('hidden');
    });

    document.querySelector('.form').classList.add('submitted');
  }

  render() {
    return (
      <>
        <Header />
        <div className="form">
          <div className="container">
            <div className="row">
              <div className="col-6 col-offset-3">

                <h2><i className="fa fa-check-circle"></i> Thank You.</h2>
                <p>Arrive to the USAHS event at your scheduled time, wear a mask, and proceed directly to the designated event entry point.</p>

                <p><em>Everyone must wear a mask. Failure to follow safety protocols may result in removal from the USAHS event.</em></p>

                {/* <p>You will also be receiving a confirmation email with this barcode and further instructions from <a href="mailto:reentry@usa.edu">reentry@usa.edu</a>.  If you do not receive the email, please contact <a href="mailto:reentry@usa.edu">reentry@usa.edu</a> or call <strong>1-855-GOUSAHS (1-855-468-7247)</strong>.</p> */}

              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Page;